const dockerfileDocs = `

### Dockerfile Documentation

In order to use the GoValuate Programming Autograder, you must successfully upload a Dockerfile, 
which will be the environment where student zip file code submissions are ran. You are free to install any and all packages for your autograder
with a few restrictions. If you are unfamiliar with Docker, please read the [Docker Documentation](https://docs.docker.com/).

##### - Starter Dockerfile

\`\`\`dockerfile
# DO NOT EDIT THIS LINE
FROM public.ecr.aws/lambda/python:3.12

# DO NOT EDIT THIS LINE
COPY . \${LAMBDA_TASK_ROOT}

# DO NOT EDIT THIS LINE
WORKDIR \${LAMBDA_TASK_ROOT}

# DO NOT EDIT THIS LINE
RUN pip install -r requirements.txt

# DO NOT EDIT THIS LINE
RUN dnf install -y bash

# =================================================

# <------ insert package installations here ------>

# =================================================

# DO NOT EDIT THIS LINE
CMD ["lambda_function.lambda_handler"]
\`\`\`

##### - Restrictions

Your Dockerfile must include all lines in the starter Dockerfile and should start from it. 
You may NOT change any of the lines labeled with \`# DO NOT EDIT THIS LINE\`.
Therefore, you may NOT change the base image (FROM), the base command (CMD), the working directory (WORKDIR), 
the bash installation, or the requirements.txt installation. Since you will be uploading only the Dockerfile, you may not add any custom COPY commands.
This initial configuration is required to make the autograder function with our infrastructure. Furthermore,
the Docker image, once built, may not exceed 9GB, and ideally, it should be much smaller than this. 
Any given Docker build has a twenty minute time limit to finish (you may request an increase via the support form), and ideally, the build should finish well before the time limit.

##### - Installations

Any packages your zip file will need should be installed via Docker \`RUN\` commands within the designated location in the starter Dockerfile.
Since the autograder base image uses Amazon Linux 2023, you should use \`dnf install -y\` to install any dependencies at the system level. The \`-y\`
flag is crucial because it automatically confirms the installation of packages, preventing any hanging caused by installation prompts. 
Furthermore, you can view the full list of packages available for download here: 
[Amazon Linux 2023 Package List](https://docs.aws.amazon.com/linux/al2023/release-notes/all-packages-AL2023.6.html).
We highly recommend attempting to build your Dockerfile on your local machine before uploading one to GoValuate. 
This will help you identify and fix any bugs before uploading it to GoValuate, preventing delays. 
Lastly, packages will be installed, and the code will be run on the ARM64 architecture.

##### - Dockerfile Uploads

A successful Dockerfile build is defined as follows: status of \`Finished\` 
and a blank \`Errors\` field. Even with this build state, we recommend 
running the autograder to be sure that the build was completely successful. 
Any case that does not satisfy these constraints is classified as 
an unsuccessful build. You may view build progress in the account settings region on GoValuate. 
You or your students may not use the programming
autograder until you have had a successful build.
If you update the Dockerfile associated with an existing Docker environment, all evaluations currently referencing that environment will
point to the new build. If you have had a successful build then initiate another build that is unsuccessful, the programming autograder
will still be able to be used; however, the build in use will be the one last classified as successful. 

`

export default dockerfileDocs;